import { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import SampleControlDashboard from "./sample-control/SampleControlDashboard";
import ViewOrders from "./sample-control/ViewOrders";
import styles from "./SampleControl.module.css";

const SampleControl = () => {
    const { isDarkMode } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Sample Control';
    }, []);

    // Extract current section from pathname for breadcrumb
    const getBreadcrumbItems = () => {
        const path = location.pathname;
        if (path === '/samples') return ['Sample Control'];
        if (path === '/samples/create-order') return ['Sample Control', 'Create New Order'];
        if (path === '/samples/view-orders') return ['Sample Control', 'View Orders'];
        if (path === '/samples/verify-cocs') return ['Sample Control', 'Verify COCs'];
        return ['Sample Control'];
    };

    const breadcrumbItems = getBreadcrumbItems();
    const isOnDashboard = location.pathname === '/samples';

    return (
        <div className={styles.sampleControl}>
            <div className={styles.header}>
                <h1>Sample Control</h1>
                <nav className={styles.breadcrumb}>
                    {breadcrumbItems.map((item, index) => (
                        <span key={index}>
                            {index === 0 ? (
                                <button 
                                    className={`${styles.breadcrumbItem} ${isOnDashboard ? styles.active : ''}`}
                                    onClick={() => navigate('/samples')}
                                >
                                    {item}
                                </button>
                            ) : index === breadcrumbItems.length - 1 ? (
                                <span className={`${styles.breadcrumbItem} ${styles.active}`}>
                                    {item}
                                </span>
                            ) : (
                                <button 
                                    className={styles.breadcrumbItem}
                                    onClick={() => {
                                        // Add navigation logic for other sections
                                    }}
                                >
                                    {item}
                                </button>
                            )}
                            {index < breadcrumbItems.length - 1 && (
                                <span className={styles.breadcrumbSeparator}>›</span>
                            )}
                        </span>
                    ))}
                </nav>
            </div>

            <div className={styles.content}>
                <Routes>
                    <Route index element={<SampleControlDashboard />} />
                    <Route path="view-orders" element={<ViewOrders />} />
                    {/* Add more routes as needed */}
                </Routes>
            </div>
        </div>
    );
};

export default SampleControl;
